import { computed, Signal, signal, WritableSignal } from "@angular/core";
import { TableParent } from "@bitwarden/web-vault/app/models/types/table.types";
import { VaultFileView } from "@bitwarden/web-vault/app/models/view/vault-file/vault-file.view";
import { resolveCabinetFileType } from "@bitwarden/web-vault/app/models/view/vault-file/cabinet-file-icon.util";
import { CabinetTableSubscription } from "./cabinet-table.subscription";

export type CabinetFileSummary = {
  total: number;
  pdf: number;
  jpg: number;
  csv: number;
};

export class CabinetTable extends CabinetTableSubscription {
  selectedFile: WritableSignal<VaultFileView> = signal<VaultFileView>(null);

  readonly summary: Signal<CabinetFileSummary> = computed(() => {
    const files = this.data() ?? [];
    // `mimeType` holds the browser's raw File.type, not the pdf/jpg/csv category — categorise
    // by file name extension instead (see cabinet-file-icon.util.ts).
    const types = files.map((row) => resolveCabinetFileType(row.fileAndAccount.file?.name));
    return {
      total: files.length,
      pdf: types.filter((type) => type === "pdf").length,
      jpg: types.filter((type) => type === "jpg").length,
      csv: types.filter((type) => type === "csv").length,
    };
  });

  constructor(_parent: TableParent) {
    super();
  }

  onRowClicked(file: VaultFileView): void {
    this.selectedFile.set(file);
  }

  clearSelection() {
    this.selectedFile.set(null);
  }
}
